var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('v-icon',{staticClass:"mr-1",staticStyle:{"margin-bottom":"2px"},attrs:{"size":"14","color":_vm.color}},[_vm._v("fas fa-"+_vm._s(_vm.icon))]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getComplexTranslations(_vm.translation)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }